import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { APP_CONFIG, AppConfig } from '../configuration';
import { DYNAMIC_LOCALE } from '@portal-front/util-locale';
import { SupportedLocale, supportedLocales } from '../consts/locale';
import { setupCookieConsentPropagation } from './cookie-consent-propagation';

const COOKIEBOT_SCRIPT_ID = 'Cookiebot';
const COOKIEBOT_SRC = 'https://consent.cookiebot.com/uc.js';
const DEFAULT_LOCALE: SupportedLocale = 'pl';

@Component({
  selector: 'login-cookiebot-script',
  standalone: true,
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookiebotScriptComponent implements OnInit {
  constructor(
    @Inject(APP_CONFIG) private readonly config: AppConfig,
    @Inject(DYNAMIC_LOCALE) private readonly locale: string,
    @Inject(DOCUMENT) private readonly document: Document,
    @Inject(PLATFORM_ID) private readonly platformId: object,
  ) {}

  public ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    setupCookieConsentPropagation(window, this.document);

    const cookiebotId = this.config.cookiebot?.id;

    if (!cookiebotId || this.document.getElementById(COOKIEBOT_SCRIPT_ID)) {
      return;
    }

    const head = this.document.head;

    if (!head) {
      return;
    }

    const script = this.document.createElement('script');
    script.id = COOKIEBOT_SCRIPT_ID;
    script.src = COOKIEBOT_SRC;
    script.setAttribute('data-culture', this.resolveLocale(this.locale));
    script.setAttribute('data-cbid', cookiebotId);
    script.type = 'text/javascript';
    script.setAttribute('data-consentmde-defaults', 'disabled');
    script.async = true;

    head.appendChild(script);
  }

  private resolveLocale(locale: string): SupportedLocale {
    if (supportedLocales.includes(locale as SupportedLocale)) {
      return locale as SupportedLocale;
    }

    return DEFAULT_LOCALE;
  }
}
